module.exports = __webpack_public_path__ + "static/nicole-82c05bc8a5a8c5d2ec62ec914b7eb85d.png";